<mat-tab-group header-less-tabs #tabs class="mt-5">
  <mat-tab>
    <div class="text-center">
      <div class="header">
        <h1>
          Welcome to ThriveNetwork
        </h1>
      </div>
      <br />
      <div class="body">
        <h5>
          Let's get you ready for clients!
        </h5>

        <form class="register-form m-4" [formGroup]="register">
          <mat-form-field>
            <mat-label>Hourly Rate</mat-label>
            <input matInput formControlName="hourRate" required>
            <mat-icon matSuffix>attach_money</mat-icon>
            <mat-error *ngIf="register.get('hourRate').hasError('required')">
              Hourly rate is required
            </mat-error>
          </mat-form-field>
          <p>
            First what is your hourly instructing rate?
          </p>
        </form>
        <button class="msr-3" mat-raised-button color="primary" (click)="setHourlyRate()">Continue</button>
      </div>
    </div>
  </mat-tab>
  <mat-tab>
    <div class="text-center">
      <h3>
        Select time ranges you are available in general.
      </h3>
      <p>You will be able to set the individual dates and times you are unavailable once your profile is complete.
      </p>
    </div>
    <br />
    <div class="row">
      <h4 class="error text-center" *ngIf="showNoTimesError">Please select the times you are available during the week
      </h4>
      <app-coaching-availability (times)="updateTimes($event)"></app-coaching-availability>
      <!-- <app-availability-component (times)="updateTimes($event)"></app-availability-component> -->
    </div>
    <div class="row">
      <div class="button-row">
        <button mat-raised-button (click)="saveTimes(true)">Skip</button>
        <button mat-raised-button color="primary" (click)="saveTimes(false)">Save Times</button>
      </div>
    </div>
  </mat-tab>
  <mat-tab>
    <div class="text-center">
      <h3>
        Please specify the timezone where you will be running sessions
      </h3>
    </div>
    <div class="row">
      <div class="col-12 center-block m-t-30 m-b-10 ">

        <ng2-timezone-picker [timezone]="user?.timeZone?user.timeZone:''" (change)="changeTimezone($event)" class=""
          showOffset=" true" guess="true">
        </ng2-timezone-picker>
        <p class="error" *ngIf="timeZoneError">Please select your timezone.</p>
      </div>
    </div>
    <div class="d-flex justify-content-between m-t-50 ">
      <button class="msr-3" mat-raised-button color="primary" (click)="back(1)">Back</button>
      <button class="msr-3" mat-raised-button color="primary" (click)="saveTimezone()">Continue</button>
    </div>
  </mat-tab>
  <mat-tab>
    <div id="goLiveTab" class="d-flex-column align-content-between ">
      <div>
        <h3>
          Are you ready to start?
        </h3>
        <p>You're on your way! Please complete your profile before going live.</p>
      </div>
      <div class="m-t-10">
        <h1 class="text-center "><i class="material-icons check">done</i></h1>
      </div>

      <div class="d-flex justify-content-between m-t-10 ">
        <button class="msr-3" mat-raised-button color="primary" (click)="back(2)">Back</button>
        <button class="msr-3" mat-raised-button color="primary" (click)="saveUser()">Save</button>
      </div>

    </div>
  </mat-tab>
</mat-tab-group>
